export default {
  overview: {
    zh_cn: '概览',
    en: 'Overview',
    zhhant: '概覽',
    he: 'סקירה',
    de: 'Überblick',
    es: 'Visión general',
    ru: 'Обзор',
    vi: 'Tổng quan',
  },
  bi: {
    zh_cn: '数据大屏',
    en: 'Big Screen Overview',
    zhhant: '数据大屏',
    he: 'סקירה במסך גדול',
    de: 'Großbildübersicht',
    es: 'Visión general de pantalla grande',
    ru: 'Обзор большого экрана',
    vi: ' Tổng quan',
  },
  stationOverview: {
    zh_cn: '站点大屏',
    en: 'Station Overview',
    zhhant: '站點大屏',
    he: 'סקירה של תחנה',
    de: 'Standortübersicht',
    es: 'Visión general de la estación',
    ru: 'Обзор станции',
    vi: 'Tổng quan trạm',
  },
  photovoltaicOverview: {
    zh_cn: '光储概览',
    en: 'Photovoltaic Overview',
    zhhant: '光儲概覽',
    he: 'סקירה של פוטו-וולטאי',
    de: 'Photovoltaik-Übersicht',
    es: 'Visión general de la fotovoltaica',
    ru: 'Обзор фотоэлектрической системы',
    vi: 'Tổng quan năng lượng mặt trời',
  },
  PhotovoltaicOverview: {
    zh_cn: '光储概览',
    en: 'Photovoltaic Overview',
    zhhant: '光儲概覽',
    he: 'סקירה של פוטו-וולטאי',
    de: 'Photovoltaik-Übersicht',
    es: 'Visión general de la fotovoltaica',
    ru: 'Обзор фотоэлектрической системы',
    vi: 'Tổng quan năng lượng mặt trời',
  },
  chargeOverview: {
    zh_cn: '充电概览',
    en: 'Charge Overview',
    zhhant: '充電概覽',
    he: 'סקירה של טעינה',
    de: 'Ladeübersicht',
    es: 'Visión general de carga',
    ru: 'Обзор зарядки',
    vi: 'Tổng quan sạc điện',
  },
  homeOverview: {
    zh_cn: '总览',
    en: 'Overview',
    zhhant: '總覽',
    he: 'סקירה',
    de: 'Überblick',
    es: 'Visión general',
    ru: 'Обзор',
    vi: 'Tổng quan',
  },
  key: {
    zh_cn: '键',
    en: 'Key',
    zhhant: '鍵',
    he: 'מפתח',
    de: 'Schlüssel',
    es: 'Clave',
    ru: 'Ключ',
    vi: 'Khóa',
  },
  value: {
    zh_cn: '值',
    en: 'Value',
    zhhant: '值',
    he: 'ערך',
    de: 'Wert',
    es: 'Valor',
    ru: 'Значение',
    vi: 'Giá trị',
  },
  field: {
    zh_cn: '字段',
    en: 'Field',
    zhhant: '字段',
    he: 'שדה',
    de: 'Feld',
    es: 'Campo',
    ru: 'Поле',
    vi: 'Lĩnh vực',
  },
  left: {
    zh_cn: '左侧',
    en: 'Left',
    zhhant: '左側',
    he: 'שמאל',
    de: 'Links',
    es: 'Izquierda',
    ru: 'Лево',
    vi: 'Trái',
  },
  home: {
    zh_cn: '运营概览',
    zhhant: '運營概覽',
    en: 'Dashboard',
    de: 'Übersicht',
    es: 'Tablero',
    ru: 'Панель мониторинга',
    vi: 'Bảng điều khiển',
  },
  resource: {
    zh_cn: '资源中心',
    en: 'Stations',
    zhhant: '資源中心',
    he: 'מרכז משאבים',
    de: 'Stationen',
    es: 'Estaciones',
    ru: 'Станции',
    vi: 'Trạm',
  },
  evseAlarms: {
    zh_cn: '监控告警',
    zhhant: '監控告警',
    en: 'Monitoring Alarms',
    he: 'אזעקות ניטור',
    de: 'Überwachungsalarme',
    es: 'Alarmas de monitoreo',
    ru: 'Сигналы тревоги мониторинга',
    vi: 'Cảnh báo giám sát',
  },
  evseAlarmList: {
    zh_cn: '告警列表',
    en: 'Alarms',
    zhhant: '告警列表',
    he: 'רשימת אזעקות',
    de: 'Alarme',
    es: 'Alarmas',
    ru: 'Сигналы тревоги',
    vi: 'Báo động',
  },
  evseAlarmRepositorys: {
    zh_cn: '告警仓库列表',
    en: 'Alarm Repositorys',
    zhhant: '告警倉庫列表',
    he: 'רשימת מאגרי אזעקות',
    de: 'Alarm Repositorys',
    es: 'Repositorios de alarmas',
    ru: 'Репозитории тревог',
    vi: 'Kho lưu trữ báo động',
  },
  evseARUpsert: {
    zh_cn: '创建/编辑告警仓库',
    en: 'Create And Edit alarm repository',
    zhhant: '創建/編輯告警倉庫',
    he: 'יצירה ועריכת מאגר אזעקות',
    de: 'Erstellen und Bearbeiten des Alarmrepositorys',
    es: 'Crear y editar repositorio de alarmas',
    ru: 'Создание и редактирование репозитория тревог',
    vi: 'Tạo và chỉnh sửa kho lưu trữ báo động',
  },
  chargeEvses: {
    zh_cn: '充电设备管理',
  },
  pvEvses: {
    zh_cn: '光伏储能设备管理',
  },
  evses: {
    zh_cn: '设备管理',
    en: 'Equipments',
    zhhant: '設備管理',
    he: 'ניהול ציוד',
    de: 'Ausrüstungen',
    es: 'Equipos',
    ru: 'Оборудование',
    vi: 'Thiết bị',
  },
  evseList: {
    zh_cn: '电桩设备管理',
    en: 'Equipment List',
    zhhant: '電樁設備管理',
    he: 'ניהול ציוד עמודי טעינה',
    de: 'Ladestationsgeräteverwaltung',
    es: 'Gestión de equipos de postes de carga',
    ru: 'Управление зарядными устройствами',
    vi: 'Quản lý thiết bị trụ sạc',
  },
  'evse-detail': {
    zh_cn: '设备详情',
    en: 'Equipment Info',
    zhhant: '設備詳情',
    he: 'מידע על ציוד',
    de: 'Ausrüstungsinformationen',
    es: 'Información del equipo',
    ru: 'Информация об оборудовании',
    vi: 'Thông tin thiết bị',
  },
  'station-detail': {
    zh_cn: '站点详情',
    en: 'Station Info',
    zhhant: '站點詳情',
    he: 'מידע על מיקום',
    de: 'Standortinformationen',
    es: 'Información de ubicación',
    ru: 'Информация о местоположении',
    vi: 'Thông tin vị trí',
  },
  'order-detail': {
    zh_cn: '订单详情',
    en: 'Order Info',
    zhhant: '訂單詳情',
    he: 'מידע על הזמנה',
    de: 'Bestellinformationen',
    es: 'Información del pedido',
    ru: 'Информация о заказе',
    vi: 'Thông tin đơn hàng',
  },
  evseUpsert: {
    zh_cn: '新增/编辑 设备',
    en: 'Create and Edit Equipment',
    zhhant: '新增/編輯 設備',
    he: 'יצירה ועריכת ציוד',
    de: 'Ausrüstung erstellen und bearbeiten',
    es: 'Crear y editar equipo',
    ru: 'Создание и редактирование оборудования',
    vi: 'Tạo và chỉnh sửa thiết bị',
  },
  evseDelete: {
    zh_cn: '删除设备',
    en: 'Delete Equipment',
    zhhant: '刪除設備',
    he: 'מחיקת ציוד',
    de: 'Ausrüstung löschen',
    es: 'Eliminar equipo',
    ru: 'Удалить оборудование',
    vi: 'Xóa thiết bị',
  },
  evseBan: {
    zh_cn: '设备禁用',
    en: 'Banned Equipments',
    zhhant: '設備禁用',
    he: 'ציוד אסור',
    de: 'Verbotene Ausrüstungen',
    es: 'Equipos prohibidos',
    ru: 'Запрещенное оборудование',
    vi: 'Thiết bị bị cấm',
  },
  evseInfo: {
    zh_cn: '设备详情',
    en: 'Equipment Info',
    zhhant: '設備詳情',
    he: 'מידע על ציוד',
    de: 'Ausrüstungsinformationen',
    es: 'Información del equipo',
    ru: 'Информация об оборудовании',
    vi: 'Thông tin thiết bị',
  },
  evseModels: {
    zh_cn: '设备型号',
    en: 'Equipment Models',
    zhhant: '設備型號',
    he: 'דגמי ציוד',
    de: 'Ausrüstungsmodelle',
    es: 'Modelos de equipos',
    ru: 'Модели оборудования',
    vi: 'Mẫu thiết bị',
  },
  evseModelList: {
    zh_cn: '设备型号列表',
    en: 'Equipment Model List',
    zhhant: '設備型號列表',
    he: 'רשימת דגמי ציוד',
    de: 'Liste der Ausrüstungsmodelle',
    es: 'Lista de modelos de equipos',
    ru: 'Список моделей оборудования',
    vi: 'Danh sách mẫu thiết bị',
  },
  evseModelUpsert: {
    zh_cn: '新增/编辑设备型号',
    en: 'Create and Edit Equipment Model',
    zhhant: '新增/編輯設備型號',
    he: 'יצירה ועריכת דגם ציוד',
    de: 'Erstellen und Bearbeiten eines Ausrüstungsmodells',
    es: 'Crear y editar modelo de equipo',
    ru: 'Создание и редактирование модели оборудования',
    vi: 'Tạo và chỉnh sửa mẫu thiết bị',
  },
  evseModelFirmwares: {
    zh_cn: '设备型号固件列表',
    en: 'Equipment Model Firmwares',
    zhhant: '設備型號固件列表',
    he: 'רשימת קושחות דגם ציוד',
    de: 'Firmware für Ausrüstungsmodelle',
    es: 'Firmware del modelo de equipo',
    ru: 'Прошивки моделей оборудования',
    vi: 'Danh sách firmware của mẫu thiết bị',
  },
  evseModelFirmwareUpsert: {
    zh_cn: '新增/编辑设备型号固件',
    en: 'Create And Edit Equipment Model',
    zhhant: '新增/編輯設備型號固件',
    he: 'יצירה ועריכת דגם ציוד',
    de: 'Erstellen und Bearbeiten eines Ausrüstungsmodells',
    es: 'Crear y editar modelo de equipo',
    ru: 'Создание и редактирование модели оборудования',
    vi: 'Tạo và chỉnh sửa mẫu thiết bị',
  },
  evseOtas: {
    zh_cn: '设备升级',
    zhhant: '設備升級',
    en: 'OTA',
    he: 'OTA',
    de: 'OTA',
    es: 'OTA',
    ru: 'OTA',
    vi: 'OTA',
  },
  evseOtaList: {
    zh_cn: '升级列表',
    en: 'OTA List',
    zhhant: '升級列表',
    he: 'רשימת OTA',
    de: 'OTA-Liste',
    es: 'Lista de OTA',
    ru: 'Список OTA',
    vi: 'Danh sách OTA',
  },
  evseOtaUpsert: {
    zh_cn: '添加/编辑OTA',
    en: 'Create And Edit Equipment OTA',
    zhhant: '添加/編輯OTA',
    he: 'יצירה ועריכת OTA ציוד',
    de: 'Erstellen und Bearbeiten von OTA-Ausrüstung',
    es: 'Crear y editar OTA de equipo',
    ru: 'Создание и редактирование оборудования OTA',
    vi: 'Tạo và chỉnh sửa OTA thiết bị',
  },
  evseOtaRetry: {
    zh_cn: '重试OTA',
    en: 'Retry OTA',
    zhhant: '重試OTA',
    he: 'ניסיון חוזר של OTA',
    de: 'OTA erneut versuchen',
    es: 'Reintentar OTA',
    ru: 'Повторить OTA',
    vi: 'Thử lại OTA',
  },
  locations: {
    zh_cn: '站点中心',
    en: 'Locations',
    zhhant: '站點中心',
    he: 'מרכז מיקומים',
    de: 'Standorte',
    es: 'Ubicaciones',
    ru: 'Места',
    vi: 'Vị trí',
  },
  locationList: {
    zh_cn: '站点列表',
    en: 'Location List',
    zhhant: '站點列表',
    he: 'רשימת מיקומים',
    de: 'Standortliste',
    es: 'Lista de ubicaciones',
    ru: 'Список мест',
    vi: 'Danh sách vị trí',
  },
  locationMap: {
    zh_cn: '站点地图',
    en: 'Location Map',
    zhhant: '站點地圖',
    he: 'מפת מיקום',
    de: 'Standortkarte',
    es: 'Mapa de ubicación',
    ru: 'Карта местоположения',
    vi: 'Bản đồ vị trí',
  },
  locationUpsert: {
    zh_cn: '创建/编辑站点',
    en: 'Create And Edit Location',
    zhhant: '創建/編輯站點',
    he: 'יצירה ועריכת מיקום',
    de: 'Standort erstellen und bearbeiten',
    es: 'Crear y editar ubicación',
    ru: 'Создать и редактировать местоположение',
    vi: 'Tạo và chỉnh sửa vị trí',
  },
  locationInfo: {
    zh_cn: '站点详情',
    en: 'Location Info',
    zhhant: '站點詳情',
    he: 'מידע על מיקום',
    de: 'Standortinformationen',
    es: 'Información de ubicación',
    ru: 'Информация о местоположении',
    vi: 'Thông tin vị trí',
  },
  locationOpen: {
    zh_cn: '开启/关闭站点',
    en: 'Open or Close Location',
    zhhant: '開啟/關閉站點',
    he: 'פתיחה או סגירה של מיקום',
    de: 'Standort öffnen oder schließen',
    es: 'Abrir o cerrar ubicación',
    ru: 'Открыть или закрыть местоположение',
    vi: 'Mở hoặc đóng vị trí',
  },
  locationLoadBalance: {
    zh_cn: '负载均衡',
    en: 'Load Balance',
    zhhant: '負載均衡',
    he: 'איזון עומס',
    de: 'Lastverteilung',
    es: 'Balanceo de carga',
    ru: 'Балансировка нагрузки',
    vi: 'Cân bằng tải',
  },
  locationLoadUpsert: {
    zh_cn: '编辑负载均衡配置',
    en: 'Edit Load Balance',
    zhhant: '編輯負載均衡配置',
    he: 'עריכת תצורת איזון עומס',
    de: 'Lastverteilung bearbeiten',
    es: 'Editar balanceo de carga',
    ru: 'Редактировать балансировку нагрузки',
    vi: 'Chỉnh sửa cấu hình cân bằng tải',
  },
  sessions: {
    zh_cn: '订单中心',
    zhhant: '訂單中心',
    en: 'Sessions',
    he: 'רשימת הזמנות',
    de: 'Sitzungen',
    es: 'Sesiones',
    ru: 'Сессии',
    vi: 'Danh sách đơn hàng',
  },
  sessionList: {
    zh_cn: '订单列表',
    en: 'Sessions',
    zhhant: '訂單列表',
    he: 'רשימת הזמנות',
    de: 'Sitzungen',
    es: 'Sesiones',
    ru: 'Сессии',
    vi: 'Danh sách đơn hàng',
  },
  sessionInfo: {
    zh_cn: '订单详情',
    en: 'Session Infos',
    zhhant: '訂單詳情',
    he: 'פרטי הזמנה',
    de: 'Sitzungsinformationen',
    es: 'Información de la sesión',
    ru: 'Информация о сеансах',
    vi: 'Chi tiết đơn hàng',
  },
  pushOrder: {
    zh_cn: '推送订单',
    en: 'Push Order',
    zhhant: '推送訂單',
    he: 'הזמנת דחיפה',
    de: 'Push-Bestellung',
    es: 'Pedido Push',
    ru: 'Отправить заказ',
    vi: 'Đơn hàng đẩy',
  },
  orderStopCharging: {
    zh_cn: '订单结束充电',
    en: 'Order End Charging',
    zhhant: '訂單結束充電',
    he: 'סיום טעינה בהזמנה',
    de: 'Ladeauftrag beenden',
    es: 'Finalizar carga de pedido',
    ru: 'Завершение зарядки заказа',
    vi: 'Kết thúc sạc đơn hàng',
  },
  sessionManualSettlement: {
    zh_cn: '手动结算订单',
    en: 'Manual Settlement Session',
    zhhant: '手動結算訂單',
    he: 'הזמנת יישוב ידני',
    de: 'Manuelle Abrechnungssitzung',
    es: 'Sesión de liquidación manual',
    ru: 'Ручное урегулирование сеанса',
    vi: 'Đơn hàng thanh toán thủ công',
  },

  priceing: {
    zh_cn: '定价 / 优惠',
    zhhant: '定價 / 優惠',
    en: 'Pricing/Discounts',
    he: 'מחירים והצעות',
    de: 'Preise und Rabatte',
    es: 'Precios y descuentos',
    ru: 'Цены и скидки',
    vi: 'Giá và ưu đãi',
  },
  pricing: {
    zh_cn: '定价 / 优惠',
    zhhant: '定價 / 優惠',
    en: 'Pricing/Discounts',
    he: 'מחירים והצעות',
    de: 'Preise und Rabatte',
    es: 'Precios y descuentos',
    ru: 'Цены и скидки',
    vi: 'Giá và ưu đãi',
  },

  tariff: {
    zh_cn: '定价策略',
    en: 'Tariff',
    zhhant: '定價策略',
    he: 'אסטרטגיית תמחור',
    de: 'Preisgestaltung',
    es: 'Estrategia de precios',
    ru: 'Стратегия ценообразования',
    vi: 'Chiến lược định giá',
  },
  activity: {
    zh_cn: '优惠活动',
    zhhant: '優惠活動',
    en: ' Discounts Activity',
    he: 'הצעות ייחוד',
    de: 'Rabattaktivitäten',
    es: 'Actividades de descuentos',
    ru: 'Акции по скидкам',
    vi: 'Hoạt động ưu đãi',
  },

  priceingUpsert: {
    zh_cn: '定价策略创建/编辑权限',
    en: 'pricing Create And Edit',
    zhhant: '定價策略創建/編輯權限',
    he: 'יצירה ועריכת אסטרטגיית תמחור',
    de: 'Preisgestaltung erstellen und bearbeiten',
    es: 'Crear y editar estrategia de precios',
    ru: 'Создание и редактирование стратегии ценообразования',
    vi: 'Tạo và chỉnh sửa chiến lược định giá',
  },
  priceingUse: {
    zh_cn: '定价策略授权使用功能',
    en: 'Pricing Authorize the use of features',
    zhhant: '定價策略授權使用功能',
    he: 'אישור אסטרטגיית תמחור לשימוש',
    de: 'Preisgestaltung zur Nutzung freigeben',
    es: 'Autorizar el uso de la estrategia de precios',
    ru: 'Утверждение использования стратегии ценообразования',
    vi: 'Cho phép sử dụng chiến lược định giá',
  },
  reporting: {
    zh_cn: '充电账单',
    zhhant: '充電賬單',
    en: 'Charging Bill',
    he: 'חשבונית טעינה',
    de: 'Ladeberechnung',
    es: 'Facturación de carga',
    ru: 'Зарядное отчет',
    vi: 'Báo cáo sạc điện',
  },
  reportingList: {
    zh_cn: '账单列表',
    en: 'Reporting List',
    zhhant: '賬單列表',
    he: 'רשימת דוחות',
    de: 'Berichtsliste',
    es: 'Lista de informes',
    ru: 'Список отчетов',
    vi: 'Danh sách báo cáo',
  },
  reportingExport: {
    zh_cn: '账单导出',
    en: 'Reporting Export',
    zhhant: '賬單導出',
    he: 'ייצוא דוחות',
    de: 'Berichts-Export',
    es: 'Exportación de informes',
    ru: 'Экспорт отчетов',
    vi: 'Xuất báo cáo',
  },
  drivers: {
    zh_cn: '用户中心',
    zhhant: '用戶中心',
    en: 'ID Tokens',
    he: 'אסימונים',
    de: 'Treiber',
    es: 'Controladores',
    ru: 'Драйверы',
    vi: 'ID Tokens',
  },
  driverUsers: {
    zh_cn: '用户列表',
    zhhant: '用戶列表',
    en: 'Driver List',
    he: 'רשימת משתמשים',
    de: 'Fahrerliste',
    es: 'Lista de usuarios',
    ru: 'Список пользователей',
    vi: 'Danh sách người dùng',
  },
  driverUpsert: {
    zh_cn: '用户编辑',
    en: 'Driver Edit',
    zhhant: '用戶編輯',
    he: 'עריכת משתמש',
    de: 'Fahrer bearbeiten',
    es: 'Editar usuario',
    ru: 'Редактирование пользователя',
    vi: 'Chỉnh sửa người dùng',
  },
  driverBan: {
    zh_cn: '用户禁用',
    en: 'Driver Banned',
    zhhant: '用戶禁用',
    he: 'משתמשים אסורים',
    de: 'Gesperrte Fahrer',
    es: 'Usuarios prohibidos',
    ru: 'Запрещенные пользователи',
    vi: 'Người dùng bị cấm',
  },
  driverInfo: {
    zh_cn: '用户信息',
    en: 'Driver Info',
    zhhant: '用戶信息',
    he: 'מידע על משתמש',
    de: 'Fahrerinformationen',
    es: 'Información del usuario',
    ru: 'Информация о пользователе',
    vi: 'Thông tin người dùng',
  },
  driverBindEvse: {
    zh_cn: '用户绑定家充设备',
    en: 'Driver Bind/Unbind Equipment',
    zhhant: '用戶綁定家充設備',
    he: 'קישור/ניתוק ציוד למשתמש',
    de: 'Ausrüstung für Fahrer binden/entbinden',
    es: 'Vincular/desvincular equipo de usuario',
    ru: 'Привязка/отвязка оборудования к пользователю',
    vi: 'Người dùng liên kết/hủy liên kết thiết bị',
  },
  cards: {
    zh_cn: '卡列表',
    en: 'RFID Cards',
    zhhant: '卡列表',
    he: 'רשימת כרטיסים',
    de: 'RFID-Karten',
    es: 'Tarjetas RFID',
    ru: 'RFID-карты',
    vi: 'Danh sách thẻ',
  },
  driverCards: {
    zh_cn: '卡列表',
    en: 'RFID Cards',
    zhhant: '卡列表',
    he: 'רשימת כרטיסים',
    de: 'RFID-Karten',
    es: 'Tarjetas RFID',
    ru: 'RFID-карты',
    vi: 'Danh sách thẻ',
  },
  driverCardUpsert: {
    zh_cn: '卡创建/编辑',
    en: 'Create And Edit RFID Card',
    zhhant: '卡創建/編輯',
    he: 'יצירה ועריכת כרטיס RFID',
    de: 'RFID-Karte erstellen und bearbeiten',
    es: 'Crear y editar tarjeta RFID',
    ru: 'Создание и редактирование карты RFID',
    vi: 'Tạo và chỉnh sửa thẻ RFID',
  },
  driverCardBan: {
    zh_cn: '卡禁用',
    en: 'Card Banned',
    zhhant: '卡禁用',
    he: 'כרטיסים אסורים',
    de: 'Verbotene Karte',
    es: 'Tarjeta prohibida',
    ru: 'Запрещенная карта',
    vi: 'Thẻ bị cấm',
  },
  driverCardDelete: {
    zh_cn: '删除卡',
    en: 'Delete Card',
    zhhant: '刪除卡',
    he: 'מחיקת כרטיס',
    de: 'Karte löschen',
    es: 'Eliminar tarjeta',
    ru: 'Удалить карту',
    vi: 'Xóa thẻ',
  },
  support: {
    zh_cn: '服务支持',
    en: 'Support',
    zhhant: '服務支持',
    he: 'תמיכה',
    de: 'Unterstützung',
    es: 'Soporte',
    ru: 'Поддержка',
    vi: 'Hỗ trợ dịch vụ',
  },
  supportFBUpsert: {
    zh_cn: '用户反馈编辑',
    en: 'Feedback Edit',
    zhhant: '用戶反饋編輯',
    he: 'עריכת משוב',
    de: 'Feedback bearbeiten',
    es: 'Editar comentarios',
    ru: 'Редактировать отзыв',
    vi: 'Chỉnh sửa phản hồi',
  },
  supportFBDelete: {
    zh_cn: '用户反馈删除',
    en: 'Feedback Delete',
    zhhant: '用戶反饋刪除',
    he: 'מחיקת משוב',
    de: 'Feedback löschen',
    es: 'Eliminar comentarios',
    ru: 'Удалить отзыв',
    vi: 'Xóa phản hồi',
  },
  supportFAQAdd: {
    zh_cn: '创建常见问答',
    en: 'Create FAQ',
    zhhant: '創建常見問答',
    he: 'יצירת שאלות נפוצות',
    de: 'FAQ erstellen',
    es: 'Crear FAQ',
    ru: 'Создать FAQ',
    vi: 'Tạo FAQ',
  },
  supportFAQDelete: {
    zh_cn: '删除常见问答',
    en: 'Delete FAQ',
    zhhant: '刪除常見問答',
    he: 'מחיקת שאלות נפוצות',
    de: 'FAQ löschen',
    es: 'Eliminar FAQ',
    ru: 'Удалить FAQ',
    vi: 'Xóa FAQ',
  },
  supportFB: {
    zh_cn: '用户反馈',
    en: 'Feedback',
    zhhant: '用戶反饋',
    he: 'משוב',
    de: 'Feedback',
    es: 'Comentarios',
    ru: 'Отзыв',
    vi: 'Phản hồi',
  },
  supportFAQ: {
    zh_cn: '常见问答',
    en: 'FAQ',
    zhhant: '常見問答',
    he: 'שאלות נפוצות',
    de: 'FAQ',
    es: 'FAQ',
    ru: 'Часто задаваемые вопросы',
    vi: 'Câu hỏi thường gặp',
  },
  supportCooperation: {
    zh_cn: '投资合作',
    en: 'Investment Cooperation',
    zhhant: '投資合作',
    he: 'שיתוף ת�得来',
    de: 'Kollaboration',
    es: 'Colaboración',
    ru: 'Сотрудничество',
    vi: 'Cộng tác',
  },
  supportRescueOrder: {
    zh_cn: '救援工单',
    en: 'Rescue Order',
    zhhant: '救援工单',
    he: 'פניות',
    de: 'Rettung',
    es: 'Rescate',
    ru: 'Сопровождение',
    vi: 'Hỗ trợ',
  },
  supportRescueConfig: {
    zh_cn: '救援配置',
    en: 'Rescue Config',
    zhhant: '救援配置',
    he: 'תמיכה',
    de: 'Unterstützung',
    es: 'Soporte',
    ru: 'Поддержка',
    vi: 'Hỗ trợ dịch vụ',
  },
  help: {
    zh_cn: '帮助',
    en: 'Help',
    zhhant: '幫助',
    he: 'עזרה',
    de: 'Hilfe',
    es: 'Ayuda',
    ru: 'Помощь',
    vi: 'Trợ giúp',
  },
  business: {
    zh_cn: '商户管理',
    zhhant: '商户管理',
    en: 'Business',
    he: 'ניהול סוחרים',
    de: 'Geschäft',
    es: 'Negocios',
    ru: 'Бизнес',
    vi: 'Kinh doanh',
  },
  brands: {
    zh_cn: '应用品牌',
    zhhant: '应用品牌',
    en: 'APP Brands',
    he: 'מותגים',
    de: 'Marken',
    es: 'Marcas',
    ru: 'Бренды',
    vi: 'Thương hiệu',
  },
  brandList: {
    zh_cn: '应用品牌列表',
    zhhant: '应用品牌列表',
    en: 'APP Brands',
    he: 'מותגים',
    de: 'Marken',
    es: 'Marcas',
    ru: 'Бренды',
    vi: 'Thương hiệu',
  },
  brand: {
    zh_cn: '品牌详情',
    en: 'Brand Detail',
    zhhant: '品牌詳情',
    he: 'פרטי מותג',
    de: 'Marke Detail',
    es: 'Detalle de la marca',
    ru: 'Детали бренда',
    vi: 'Chi tiết thương hiệu',
  },
  operators: {
    zh_cn: '商户列表',
    zhhant: '商戶列表',
    en: 'Operators',
    he: 'ניהול סוחרים',
    de: 'Betreiber',
    es: 'Operadores',
    ru: 'Операторы',
    vi: 'Nhà điều hành',
  },
  'brand-detail': {
    zh_cn: '移动应用详情',
    zhhant: '移动应用详情',
    en: 'APP Brand Detail',
    he: 'פרטי מותג',
    de: 'Marke Detail',
    es: 'Detalle de la marca',
    ru: 'Детали бренда',
    vi: 'Chi tiết ứng dụng',
  },
  'operator-detail': {
    zh_cn: '商户详情',
    en: 'Operator Detail',
    zhhant: '商戶詳情',
    he: 'פרטי סוחר',
    de: 'Betreiber Detail',
    es: 'Detalle del operador',
    ru: 'Детали оператора',
    vi: 'Chi tiết nhà điều hành',
  },
  managers: {
    zh_cn: '管理员',
    en: 'Managers',
    zhhant: '管理員',
    he: 'מנהלים',
    de: 'Manager',
    es: 'Administradores',
    ru: 'Менеджеры',
    vi: 'Quản lý',
  },
  managerList: {
    zh_cn: '管理员列表',
    en: 'Manager List',
    zhhant: '管理員列表',
    he: 'רשימת מנהלים',
    de: 'Manager-Liste',
    es: 'Lista de administradores',
    ru: 'Список менеджеров',
    vi: 'Danh sách quản lý',
  },
  roles: {
    zh_cn: '角色',
    en: 'Roles',
    zhhant: '角色',
    he: 'תפקידים',
    de: 'Rollen',
    es: 'Roles',
    ru: 'Роли',
    vi: 'Vai trò',
  },
  roleList: {
    zh_cn: '角色列表',
    en: 'Role List',
    zhhant: '角色列表',
    he: 'רשימת תפקידים',
    de: 'Rollen-Liste',
    es: 'Lista de roles',
    ru: 'Список ролей',
    vi: 'Danh sách vai trò',
  },
  alarms: {
    zh_cn: '告警信息',
    en: 'Alarms',
    zhhant: '告警信息',
    he: 'אזעקות',
    de: 'Alarme',
    es: 'Alarmas',
    ru: 'Оповещения',
    vi: 'Báo động',
  },
  alarmRepository: {
    zh_cn: '告警仓库信息',
    zhhant: '告警仓库信息',
    he: 'אזעקות מאגר',
    de: 'Alarm-Repository',
    es: 'Repositorio de alarmas',
    ru: 'Справочник оповещений',
    vi: 'Kho báo động',
  },
  operatorAdd: {
    zh_cn: '创建商户',
    en: 'Create Operator',
    zhhant: '創建商戶',
    he: 'יצירת סוחר',
    de: 'Betreiber erstellen',
    es: 'Crear operador',
    vi: 'Tạo nhà điều hành',
    ru: 'Создать оператора',
  },
  reportingRegen: {
    zh_cn: '重新生成报表',
    en: 'Regenerate Report',
    zhhant: '重新生成報表',
    he: 'רענן דוחות',
    de: 'Bericht regenerieren',
    es: 'Regenerar informe',
    ru: 'Перегенерировать отчет',
    vi: 'Tái tạo báo cáo',
  },
  settings: {
    zh_cn: '设置',
    en: 'Settings',
    zhhant: '設置',
    he: 'הגדרות',
    de: 'Einstellungen',
    es: 'Configuraciones',
    ru: 'Настройки',
    vi: 'Cài đặt',
  },
  system: {
    zh_cn: '系统设置',
    en: 'System',
    zhhant: '系統設置',
    he: 'מערכת',
    de: 'System',
    es: 'Sistema',
    ru: 'Система',
    vi: 'Hệ thống',
  },
  alarm: {
    zh_cn: '告警',
    en: 'Alarms',
    zhhant: '告警',
    he: 'אזעקה',
    de: 'Alarm',
    es: 'Alarma',
    ru: 'Оповещение',
    vi: 'Báo động',
  },
  theSystemHas: {
    zh_cn: '系统有',
    en: 'Alarms',
    zhhant: '系統有',
    he: 'מערכת יש',
    de: 'System hat',
    es: 'El sistema tiene',
    ru: 'Система имеет',
    vi: 'Hệ thống có',
  },
  noWarning: {
    zh_cn: '暂无告警',
    en: 'No alarm',
    zhhant: '暫無告警',
    he: 'אין אזעקות',
    de: 'Keine Alarme',
    es: 'Sin alarmas',
    ru: 'Нет оповещений',
    vi: 'Không có báo động',
  },
  users: {
    zh_cn: '用户',
    en: 'Users',
    zhhant: '用戶',
    he: 'משתמשים',
    de: 'Benutzer',
    es: 'Usuarios',
    ru: 'Пользователи',
    vi: 'Người dùng',
  },
  'user-detail': {
    zh_cn: '用户详情',
    en: 'User Detail',
    zhhant: '用戶詳情',
    he: 'פרטי משתמש',
    de: 'Benutzer Detail',
    es: 'Detalle del usuario',
    ru: 'Детали пользователя',
    vi: 'Chi tiết người dùng',
  },
  usersManagement: {
    zh_cn: '管理员',
    en: 'Managers',
    zhhant: '管理員',
    he: 'ניהול מנהלים',
    de: 'Manager',
    es: 'Administradores',
    ru: 'Менеджеры',
    vi: 'Quản lý',
  },
  logOut: {
    zh_cn: '退出登录',
    en: 'Logout',
    zhhant: '退出登錄',
    he: 'התנתק',
    de: 'Abmelden',
    es: 'Cerrar sesión',
    ru: 'Выйти',
    vi: 'Đăng xuất',
  },
  'not-found': {
    zh_cn: '404',
    en: '404',
    zhhant: '404',
    he: '404',
    de: '404',
    es: '404',
    ru: '404',
    vi: '404',
  },
  noteAlertClickView: {
    zh_cn: '条告警，点击查看',
    en: 'alerts, Click to view',
    zhhant: '條告警，點擊查看',
    he: 'התראות, לחץ לצפייה',
    de: 'Alarme, klicken Sie um zu sehen',
    es: 'alertas, haga clic para ver',
    ru: 'оповещения, нажмите чтобы посмотреть',
    vi: 'cảnh báo, nhấp để xem',
  },
  loggedOut: {
    zh_cn: '已退出登录',
    en: 'Logged out',
    zhhant: '已退出登錄',
    he: 'התנתקת',
    de: 'Abgemeldet',
    es: 'Desconectado',
    ru: 'Вышли из системы',
    vi: 'Đã đăng xuất',
  },
  whetherToLogOutOrNot: {
    zh_cn: '是否退出登录？',
    en: 'Confirm to logout',
    zhhant: '是否退出登錄？',
    he: 'האם להתנתק?',
    de: 'Möchten Sie sich abmelden?',
    es: '¿Confirmar cierre de sesión?',
    ru: 'Подтвердите выход',
    vi: 'Xác nhận đăng xuất',
  },
  signOut: {
    zh_cn: '退出',
    en: 'Logout',
    zhhant: '退出',
    he: 'התנתק',
    de: 'Abmelden',
    es: 'Salir',
    ru: 'Выход',
    vi: 'Đăng xuất',
  },
  operatorUpsert: {
    zh_cn: '编辑商户',
    zhhant: '編輯商戶',
    en: 'Edit Operator',
    he: 'עריכת סוחר',
    de: 'Betreiber bearbeiten',
    es: 'Editar operador',
    ru: 'Редактировать оператора',
    vi: 'Chỉnh sửa nhà điều hành',
  },
  operatorBan: {
    zh_cn: '禁用运营商',
    en: 'Banned Operator',
    zhhant: '禁用運營商',
    he: 'חסום סוחר',
    de: 'Betreiber sperren',
    es: 'Operador bloqueado',
    ru: 'Заблокированный оператор',
    vi: 'Nhà điều hành bị cấm',
  },
  managerAdd: {
    zh_cn: '添加管理员',
    zhhant: '添加管理員',
    en: 'Add Manager',
    he: 'הוספת מנהל',
    de: 'Manager hinzufügen',
    es: 'Agregar administrador',
    ru: 'Добавить менеджера',
    vi: 'Thêm quản lý',
  },
  managerUpsert: {
    zh_cn: '编辑管理员',
    zhhant: '編輯管理員',
    en: 'Edit Manager',
    he: 'עריכת מנהל',
    de: 'Manager bearbeiten',
    es: 'Editar administrador',
    ru: 'Редактировать менеджера',
    vi: 'Chỉnh sửa quản lý',
  },
  managerBan: {
    zh_cn: '禁用管理员',
    en: 'Banned Manager',
    zhhant: '禁用管理員',
    he: 'חסום מנהל',
    de: 'Manager sperren',
    es: 'Administrador bloqueado',
    ru: 'Заблокированный менеджер',
    vi: 'Quản lý bị cấm',
  },
  managerDelete: {
    zh_cn: '删除管理员',
    en: 'Delete Manager',
    zhhant: '刪除管理員',
    he: 'מחק מנהל',
    de: 'Manager löschen',
    es: 'Eliminar administrador',
    ru: 'Удалить менеджера',
    vi: 'Xóa quản lý',
  },
  rolesAdd: {
    zh_cn: '添加角色',
    en: 'Add Manager Role',
    zhhant: '添加管理員角色',
    he: 'הוספת תפקיד מנהל',
    de: 'Manager-Rolle hinzufügen',
    es: 'Agregar rol de administrador',
    ru: 'Добавить роль менеджера',
    vi: 'Thêm vai trò quản lý',
  },
  rolesUpsert: {
    zh_cn: '编辑角色',
    zhhant: '編輯管理員角色',
    en: 'Edit Manager Role',
    he: 'עריכת תפקיד מנהל',
    de: 'Manager-Rolle bearbeiten',
    es: 'Editar rol de administrador',
    ru: 'Редактировать роль менеджера',
    vi: 'Chỉnh sửa vai trò quản lý',
  },
  rolesBan: {
    zh_cn: '禁用角色',
    en: 'Banned Manager Role',
    zhhant: '禁用管理員角色',
    he: 'חסום תפקיד מנהל',
    de: 'Manager-Rolle sperren',
    es: 'Rol de administrador bloqueado',
    ru: 'Заблокированная роль менеджера',
    vi: 'Vai trò quản lý bị cấm',
  },
  evseReboot: {
    zh_cn: '重启',
    en: 'Reboot',
    zhhant: '重新啟動',
    he: 'הפעלה מחדש',
    de: 'Neustart',
    es: 'Reiniciar',
    ru: 'Перезагрузить',
    vi: 'Khởi động lại',
  },
  evseReset: {
    zh_cn: '恢复出厂设置',
    en: 'Reset',
    zhhant: '恢復設定',
    he: 'אפס',
    de: 'Zurücksetzen',
    es: 'Restablecer',
    ru: 'Восстановить',
    vi: 'Đặt lại',
  },
  evseClearCache: {
    zh_cn: '清除缓存',
    en: 'Clear Cache',
    zhhant: '清除緩存',
    he: 'נקה מטמון',
    de: 'Cache löschen',
    es: 'Limpiar caché',
    ru: 'Очистить кэш',
    vi: 'Xóa bộ nhớ đệm',
  },
  evseClearProfile: {
    zh_cn: '清除配置文件',
    en: 'Clear Profile',
    zhhant: '清除設定檔',
    he: 'נקה פרופיל',
    de: 'Profil löschen',
    es: 'Limpiar perfil',
    ru: 'Очистить профиль',
    vi: 'Xóa hồ sơ',
  },
  evseTriggerConnector: {
    zh_cn: '刷新连接器',
    en: 'Trigger Connector',
    zhhant: '觸發連接器',
    he: 'פעילות מחוץ',
    de: 'Trigger-Konnektor',
    es: 'Desencadenar conector',
    ru: 'Активировать соединитель',
    vi: 'Duyệt kết nối',
  },
  evseTriggerOrder: {
    zh_cn: '刷新订单',
    en: 'Trigger Order',
    zhhant: '觸發訂單',
    he: 'פעילות הזמנה',
    de: 'Trigger-Bestellung',
    es: 'Desencadenar pedido',
    ru: 'Активировать заказ',
    vi: 'Duyệt đơn hàng',
  },
  evseUnlockConnector: {
    zh_cn: '解锁连接器',
    en: 'Unlock Connector',
    zhhant: '解除連接器',
    he: 'פתיחת מחוץ',
    de: 'Konnektor entsperren',
    es: 'Desbloquear conector',
    ru: 'Разблокировать соединитель',
    vi: 'Mở khóa kết nối',
  },
  evseRunLogList: {
    zh_cn: '运行日志列表',
    en: 'EVSE Run Log List',
    zhhant: '運行日誌列表',
    he: 'רשימת יומני ריצה של EVSE',
    de: 'EVSE Ausführungsprotokollliste',
    es: 'Lista de registros de ejecución de EVSE',
    ru: 'Список журналов выполнения EVSE',
    vi: 'Danh sách nhật ký hoạt động EVSE',
  },
  evseRunLogUpload: {
    zh_cn: '运行日志上传',
    en: 'EVSE Run Log Upload',
    zhhant: '運行日誌上傳',
    he: 'העלאת יומני ריצה של EVSE',
    de: 'EVSE Ausführungsprotokoll hochladen',
    es: 'Subir registros de ejecución de EVSE',
    ru: 'Загрузка журналов выполнения EVSE',
    vi: 'Tải lên nhật ký hoạt động EVSE',
  },
  evseConfigSet: {
    zh_cn: '设备配置设置',
    en: 'EVSE Device Config Set',
    zhhant: '設備配置設置',
    he: 'הגדרת תצורת מכשיר EVSE',
    de: 'EVSE Geräte Konfiguration setzen',
    es: 'Configurar dispositivo EVSE',
    ru: 'Настройка конфигурации устройства EVSE',
    vi: 'Cài đặt cấu hình thiết bị EVSE',
  },
  evseConfigGet: {
    zh_cn: '设备配置获取',
    en: 'EVSE Device Config Get',
    zhhant: '設備配置獲取',
    he: 'קבלת תצורת מכשיר EVSE',
    de: 'EVSE Geräte Konfiguration abrufen',
    es: 'Obtener configuración de dispositivo EVSE',
    ru: 'Получить конфигурацию устройства EVSE',
    vi: 'Lấy cấu hình thiết bị EVSE',
  },
  evseProfileList: {
    zh_cn: '充电配置列表',
    en: 'EVSE Charging Config List',
    zhhant: '充電配置列表',
    he: 'רשימת הגדרות טעינה EVSE',
    de: 'EVSE Ladeconfigurationsliste',
    es: 'Lista de configuraciones de carga de EVSE',
    ru: 'Список конфигураций зарядки EVSE',
    vi: 'Danh sách cấu hình sạc EVSE',
  },
  evseProfileLately: {
    zh_cn: '最近充电配置',
    en: 'EVSE Recent Charging Config',
    zhhant: '最近充電配置',
    he: 'הגדרת טעינה אחרונה EVSE',
    de: 'EVSE Letzte Ladeconfig',
    es: 'Configuración de carga reciente de EVSE',
    ru: 'Последняя конфигурация зарядки EVSE',
    vi: 'Cấu hình sạc gần đây EVSE',
  },
  evseProfileUpsert: {
    zh_cn: '充电配置增删改',
    en: 'EVSE Charging Config Upsert',
    zhhant: '充電配置增刪改',
    he: 'הוספה או עדכון הגדרת טעינה EVSE',
    de: 'EVSE Ladeconfig Upsert',
    es: 'Actualizar o insertar configuración de carga de EVSE',
    ru: 'Добавить или обновить конфигурацию зарядки EVSE',
    vi: 'Cập nhật hoặc thêm mới cấu hình sạc EVSE',
  },
  evseTricelessOTA: {
    zh_cn: '设备无感升级',
    en: 'EVSE Triceless Upgrade',
    zhhant: '設備無感升級',
    he: 'שדרוג EVSE ללא חוויה',
    de: 'EVSE Triceless Upgrade',
    es: 'Actualización Triceless de EVSE',
    ru: 'EVSE Triceless обновление',
    vi: 'Nâng cấp Triceless EVSE',
  },
  evseOperation: {
    zh_cn: '设备运营',
    en: 'EVSE Operation',
    zhhant: '設備運營',
    he: 'הפעלה של EVSE',
    de: 'EVSE Betrieb',
    es: 'Operación EVSE',
    ru: 'Операция EVSE',
    vi: 'Hoạt động EVSE',
  },
  evseNonOperation: {
    zh_cn: '设备下架',
    en: 'EVSE Unavailable',
    zhhant: '設備下架',
    he: 'EVSE לא זמין',
    de: 'EVSE Nicht verfügbar',
    es: 'EVSE No disponible',
    ru: 'EVSE Недоступно',
    vi: 'EVSE Không khả dụng',
  },
  evseSendPricing: {
    zh_cn: '下发定价信息',
    zhhant: '下發定價信息',
    en: 'Send Pricing Info',
    he: 'שליחת מידע על מחירים',
    de: 'Preisinformationen senden',
    es: 'Enviar información de precios',
    ru: 'Отправить информацию по ценам',
    vi: 'Gửi thông tin giá',
  },
  evseSendQrcode: {
    zh_cn: '下发二维码',
    zhhant: '下發二維碼',
    en: 'Send QR Code',
    he: 'שליחת קוד QR',
    de: 'QR-Code senden',
    es: 'Enviar código QR',
    ru: 'Отправить QR код',
    vi: 'Gửi mã QR',
  },
  brandUpsert: {
    zh_cn: '创建/修改品牌应用',
    zhhant: '創建/修改品牌應用',
    en: 'Create/Update Brand App',
    he: 'יצירה/עדכון של אפליקציית מותג',
    de: 'Marken-App erstellen/aktualisieren',
    es: 'Crear/actualizar aplicación de marca',
    ru: 'Создать/обновить приложение бренда',
    vi: 'Tạo / Cập nhật ứng dụng thương hiệu',
  },
  brandInfo: {
    zh_cn: '品牌应用详情',
    zhhant: '品牌应用详情',
    en: 'Brand App Detail',
    he: 'פרטי אפליקציית מותג',
    de: 'Marken-App-Detail',
    es: 'Detalles de la aplicación de marca',
    ru: 'Подробности приложения бренда',
    vi: 'Chi tiết ứng dụng thương hiệu',
  },
  brandAuthList: {
    zh_cn: '品牌应用授权列表',
    zhhant: '品牌应用授权列表',
    en: 'Brand App Auth List',
    he: 'רשימת אישורי אפליקציית מותג',
    de: 'Marken-App-Auth-Liste',
    es: 'Lista de autorización de aplicación de marca',
    ru: 'Список авторизации приложения бренда',
    vi: 'Danh sách ủy quyền ứng dụng thương hiệu',
  },
  brandAuth: {
    zh_cn: '品牌应用授权/取消授权商户',
    zhhant: '品牌应用授权/取消授权商户',
    en: 'Brand App Auth/Unauth Merchant',
    he: 'אישור/ביטול אישור של סוחר באפליקציית מותג',
    de: 'Marken-App-Auth/Unauth Händler',
    es: 'Autorizar/Desautorizar Comerciante en Aplicación de Marca',
    ru: 'Авторизация/Отмена авторизации торговца в приложении бренда',
    vi: 'Ủy quyền / Hủy ủy quyền thương gia trên ứng dụng thương hiệu',
  },
  operatorInfo: {
    zh_cn: '运营商详情',
    zhhant: '運營商詳情',
    en: 'Operator Detail',
    he: 'פרטי המפעיל',
    de: 'Betreiber-Detail',
    es: 'Detalles del operador',
    ru: 'Подробности оператора',
    vi: 'Chi tiết nhà mạng',
  },
  brandApp: {
    zh_cn: '品牌应用',
    zhhant: '品牌应用',
    en: 'Brand App',
    he: 'אפליקציית מותג',
    de: 'Marken-App',
    es: 'Aplicación de marca',
    ru: 'Приложение бренда',
    vi: 'Ứng dụng thương hiệu',
  },
  brandAppUpsert: {
    zh_cn: '增加/修改品牌应用',
    zhhant: '增加/修改品牌应用',
    en: 'Add/Update Brand App',
    he: 'הוספה/עדכון של אפליקציית מותג',
    de: 'Marken-App hinzufügen/aktualisieren',
    es: 'Agregar/actualizar aplicación de marca',
    ru: 'Добавить/обновить приложение бренда',
    vi: 'Thêm / Cập nhật ứng dụng thương hiệu',
  },
  brandNoti: {
    zh_cn: '品牌应用通知',
    zhhant: '品牌应用通知',
    en: 'Brand App Notification',
    he: 'הודעת אפליקציית מותג',
    de: 'Marken-App-Benachrichtigung',
    es: 'Notificación de aplicación de marca',
    ru: 'Уведомление приложения бренда',
    vi: 'Thông báo ứng dụng thương hiệu',
  },
  brandNotiUpsert: {
    zh_cn: '增加/修改品牌应用通知',
    zhhant: '增加/修改品牌应用通知',
    en: 'Add/Update Brand App Notification',
    he: 'הוספה/עדכון של הודעת אפליקציית מותג',
    de: 'Marken-App-Benachrichtigung hinzufügen/aktualisieren',
    es: 'Agregar/actualizar notificación de aplicación de marca',
    ru: 'Добавить/обновить уведомление приложения бренда',
    vi: 'Thêm / Cập nhật thông báo ứng dụng thương hiệu',
  },
  paymentChannel: {
    zh_cn: '支付渠道',
    zhhant: '支付渠道',
    en: 'Payment Channel',
    he: 'ערוץ תשלום',
    de: 'Zahlungskanal',
    es: 'Canal de pago',
    ru: 'Платежный канал',
    vi: 'Kênh thanh toán',
  },
  paymentChannelUpsert: {
    zh_cn: '增加/修改支付渠道',
    zhhant: '增加/修改支付渠道',
    en: 'Add/Update Payment Channel',
    he: 'הוספה/עדכון של ערוץ תשלום',
    de: 'Zahlungskanal hinzufügen/aktualisieren',
    es: 'Agregar/actualizar canal de pago',
    ru: 'Добавить/обновить платежный канал',
    vi: 'Thêm / Cập nhật kênh thanh toán',
  },
  profitsharing: {
    zh_cn: '清分管理',
    zhhant: '清分管理',
    en: 'Profit Sharing',
    he: 'ניהול חלוקת רווחים',
    de: 'Profit-Sharing',
    es: 'Gestión de la división de beneficios',
    ru: 'Управление распределением доходов',
    vi: 'Quản lý phân chia lợi nhuận',
  },
  strategys: {
    zh_cn: '策略管理',
    zhhant: '策略管理',
    en: 'Strategy Management',
    he: 'ניהול אסטרטגי',
    de: 'Strategieverwaltung',
    es: 'Gestión de estrategia',
    ru: 'Управление стратегией',
    vi: 'Quản lý chiến lược',
  },
  strategyList: {
    zh_cn: '清分策略列表',
    zhhant: '清分策略列表',
    en: 'Strategy List',
    he: 'רשימת אסטרטגיות',
    de: 'Strategie-Liste',
    es: 'Lista de estrategias',
    ru: 'Список стратегий',
    vi: 'Danh sách chiến lược',
  },
  payees: {
    zh_cn: '收款人管理',
    zhhant: '收款人管理',
    en: 'Payee Management',
    he: 'ניהול מקבל תשלום',
    de: 'Zahlungsempfänger-Management',
    es: 'Gestión de beneficiario',
    ru: 'Управление плательщиком',
    vi: 'Quản lý Người nhận',
  },
  payeeList: {
    zh_cn: '收款人列表',
    zhhant: '收款人列表',
    en: 'Payee List',
    he: 'רשימת מקבל תשלום',
    de: 'Zahlungsempfänger-Liste',
    es: 'Lista de beneficiarios',
    ru: 'Список плательщиков',
    vi: 'Danh sách Người nhận',
  },
  transactions: {
    zh_cn: '交易流水',
    zhhant: '交易流水',
    en: 'Transaction Flow',
    he: 'זרימת עסקאות',
    de: 'Transaktionsfluss',
    es: 'Flujo de transacciones',
    ru: 'Поток транзакций',
    vi: 'Lưu lượng giao dịch',
  },
  withdraws: {
    zh_cn: '提现管理',
    zhhant: '提现管理',
    en: 'Withdraw Management',
    he: 'ניהול משיכה',
    de: 'Auszahlungsverwaltung',
    es: 'Gestión de retiro',
    ru: 'Управление выводом средств',
    vi: 'Quản lý rút tiền',
  },
  withdrawList: {
    zh_cn: '提现列表',
    zhhant: '提现列表',
    en: 'Withdraw List',
    he: 'רשימת משיכה',
    de: 'Auszahlungsliste',
    es: 'Lista de retiro',
    ru: 'Список выводов средств',
    vi: 'Danh sách rút tiền',
  },
  psTransactionList: {
    zh_cn: '清分流水',
    zhhant: '清分流水',
    en: 'Profit Sharing Transactions',
    he: 'זרימת חלוקת רווחים',
    de: 'Profit-Sharing-Transaktionen',
    es: 'Transacciones de división de beneficios',
    ru: 'Транзакции распределения доходов',
    vi: 'Lưu lượng phân chia lợi nhuận',
  },
  barrierGate: {
    zh_cn: '道闸管理',
    zhhant: '道闸管理',
    en: 'Barrier Gate Management',
    he: 'ניהול שער מחסום',
    de: 'Verwaltung von Barrierentoren',
    es: 'Gestión de puerta de barrera',
    ru: 'Управление барьерным вратом',
    vi: 'Quản lý cổng cản',
  },
  pricingTariff: {
    zh_cn: '计费策略',
    zhhant: '计费策略',
    en: 'Pricing Tariff',
    he: 'מדיניות מחירות',
    de: 'Preisstrategie',
    es: 'Estrategia de precios',
    ru: 'Стратегия тарификации',
    vi: 'Phương pháp thanh toán',
  },
  barrierGateUpsert: {
    zh_cn: '增加/修改道闸',
    zhhant: '增加/修改道闸',
    en: 'Add/Update Barrier Gate',
    he: 'הוספה/עדכון של שער מחסום',
    de: 'Barrierentor hinzufügen/aktualisieren',
    es: 'Agregar/actualizar puerta de barrera',
    ru: 'Добавить/обновить барьерное врата',
    vi: 'Thêm / Cập nhật cổng cản',
  },
  strategyAdd: {
    zh_cn: '增加策略',
    zhhant: '增加策略',
    en: 'Add Strategy',
    he: 'הוספת אסטרטגיה',
    de: 'Strategie hinzufügen',
    es: 'Agregar estrategia',
    ru: 'Добавить стратегию',
    vi: 'Thêm chiến lược',
  },
  strategyUpsert: {
    zh_cn: '修改策略',
    zhhant: '修改策略',
    en: 'Update Strategy',
    he: 'עדכון אסטרטגיה',
    de: 'Strategie aktualisieren',
    es: 'Actualizar estrategia',
    ru: 'Обновить стратегию',
    vi: 'Cập nhật chiến lược',
  },
  strategyAuthList: {
    zh_cn: '策略授权列表',
    zhhant: '策略授权列表',
    en: 'Strategy Authorization List',
    he: 'רשימת אישור אסטרטגי',
    de: 'Liste der Strategie-Autorisierung',
    es: 'Lista de autorización de estrategia',
    ru: 'Список авторизации стратегии',
    vi: 'Danh sách ủy quyền chiến lược',
  },
  strategyAuthAdd: {
    zh_cn: '增加策略授权',
    zhhant: '增加策略授权',
    en: 'Add Strategy Authorization',
    he: 'הוספת אישור אסטרטגי',
    de: 'Strategie-Autorisierung hinzufügen',
    es: 'Agregar autorización de estrategia',
    ru: 'Добавить авторизацию стратегии',
    vi: 'Thêm ủy quyền chiến lược',
  },
  strategyAuthDelete: {
    zh_cn: '删除策略授权',
    zhhant: '删除策略授权',
    en: 'Delete Strategy Authorization',
    he: 'מחיקת אישור אסטרטגי',
    de: 'Strategie-Autorisierung löschen',
    es: 'Eliminar autorización de estrategia',
    ru: 'Удалить авторизацию стратегии',
    vi: 'Xóa ủy quyền chiến lược',
  },
  payeeAdd: {
    zh_cn: '增加收款人',
    zhhant: '增加收款人',
    en: 'Add Payee',
    he: 'הוספת מקבל תשלום',
    de: 'Zahlungsempfänger hinzufügen',
    es: 'Agregar beneficiario',
    ru: 'Добавить плательщиком',
    vi: 'Thêm Người nhận',
  },
  payeeUpsert: {
    zh_cn: '修改收款人',
    zhhant: '修改收款人',
    en: 'Update Payee',
    he: 'עדכון מקבל תשלום',
    de: 'Zahlungsempfänger aktualisieren',
    es: 'Actualizar beneficiario',
    ru: 'Обновить плательщиком',
    vi: 'Cập nhật Người nhận',
  },
  withdrawApply: {
    zh_cn: '提现申请',
    zhhant: '提现申请',
    en: 'Withdraw Application',
    he: 'בקשת משיכה',
    de: 'Auszahlungsantrag',
    es: 'Solicitud de retiro',
    ru: 'Заявка на вывод средств',
    vi: 'Đơn rút tiền',
  },
  withdrawAudit: {
    zh_cn: '提现审核',
    zhhant: '提现审核',
    en: 'Withdraw Audit',
    he: 'סקירת משיכה',
    de: 'Auszahlungsprüfung',
    es: 'Auditoría de retiro',
    ru: 'Проверка вывода средств',
    vi: 'Kiểm tra rút tiền',
  },
  pstransactions: {
    zh_cn: '清分交易记录',
    zhhant: '清分交易记录',
    en: 'Clearing Transaction Records',
    he: 'רשומות על פעולות ניקוי',
    de: 'Klärungstransaktionsaufzeichnungen',
    es: 'Registros de transacciones de liquidación',
    ru: 'Записи транзакций по клеринговым',
    vi: 'Bản ghi giao dịch phân loại',
  },
  brandOperator: {
    zh_cn: '品牌运营商',
    zhhant: '品牌运营商',
    en: 'Brand Operator',
    he: 'מפעיל המותג',
    de: 'Markenbetreiber',
    es: 'Operador de marca',
    ru: 'Оператор бренда',
    vi: 'Nhà điều hành thương hiệu',
  },
  brandOperatorDesc: {
    zh_cn: '商户拥有自己的小程序和支付渠道。权限维度(商户)',
    zhhant: '商户拥有自己的小程序和支付渠道。权限维度(商户)',
    en: 'Merchants own their own mini-programs and payment channels. Permission dimension (merchant)',
    he: 'בoutlets משתמשים ב-mini-programs שלו, ומעבדים את תשלומיו דרך שירותי תשלום שלו. מרחב ההרשאות (בוטל)',
    de: 'Händler besitzen ihre eigenen Mini-Programme und Zahlungskanäle. Berechtigungsbereich (Händler)',
    es: 'Los comercios poseen sus propios mini-programas y canales de pago. Dimensión de permisos (comerciante)',
    ru: 'Брендовые операторы, которые управляют своими магазинами и их каналами оплаты. Размер прав (магазин)',
    vi: 'Nhà điều hành thương hiệu, có quyền quản lý các trang web và các kênh thanh toán của doanh nghiệp. Phạm vi quyền (nhà cung cấp)',
  },
  agentOperator: {
    zh_cn: '托管运营商',
    zhhant: '托管运营商',
    en: 'Agent Operator',
    he: 'פעילות סוכן',
    ru: 'Оператор-агент',
    vi: 'Nhà điều hành đại lý',
    de: 'Agenten-Betreiber',
    es: 'Operador de agentes',
  },
  agentOperatorDesc: {
    zh_cn: '商户通过品牌运营商户进行运营设备，没有自己的小程序和支付渠道。权限维度(商户)',
    zhhant: '商户通过品牌运营商户进行运营设备，没有自己的小程序和支付渠道。权限维度(商户)',
    en: 'Merchants operate their own devices through the brand operator, do not have their own mini-programs and payment channels. Permission dimension (merchant)',
    he: 'מוכרים מבצעים את מכשיריהם שלהם דרך מפעיל המותג, אין להם מיני-תוכנות משלהם וערוצים לשילוח. מרחב ההרשאות (מוכר)',
    de: 'Händler betreiben ihre eigenen Geräte über den Brandoperator, haben keine eigenen Mini-Programme und Zahlungskanäle. Berechtigungsdimension (Händler)',
    vi: 'Nhà bán lẻ thực hiện các thiết bị của mình thông qua nhà điều hành thương hiệu, không có các chương trình mini và kênh thanh toán của riêng họ. Không gian quyền (nhà bán lẻ)',
    ru: 'Торговцы используют для эксплуатации устройств бренд-оператора, не имеют собственных мини-программ и платежных каналов. Изменить размер (торговец)',
    es: 'Los comerciantes operan sus propios dispositivos a través del operador de marca, no tienen sus propias mini-aplicaciones y canales de pago. Dimensión de permisos (comerciante)',
  },
  stationManager: {
    zh_cn: '站点管理员',
    zhhant: '站点管理员',
    en: 'Station Manager',
    he: 'מנהל תחנה',
    de: 'Stationsmanager',
    es: 'Administrador de estación',
    ru: 'Менеджер станции',
    vi: 'Quản lý trạm',
  },
  stationManagerDesc: {
    zh_cn: '负责管理以及查看站点相关信息。权限维度(站点)',
    zhhant: '负责管理以及查看站点相关信息。权限维度(站点)',
    en: 'Responsible for managing and viewing site information. Permission dimension (site)',
    he: 'מנהל תחנה אחראי על ניהול וצפייה בפרטי תחנה. מרחב ההרשאות (תחנה)',
    de: 'Verantwortlich für die Verwaltung und die Ansicht von Standortinformationen. Berechtigungsdimension (Standort)',
    es: 'Responsable de la administración y la visualización de la información del sitio. Dimensión de permisos (sitio)',
    ru: 'Ответственный за управление и просмотр информации о станции. Изменить размер (станция)',
    vi: 'Quản lý trạm, quản lý và xem thông tin trạm. Quyền (trạm)',
  },
  psPayees: {
    zh_cn: '分润成员',
    zhhant: '分润成员',
    en: 'Profit Sharing Members',
    he: 'חברי שיתוף רווחים',
    de: 'Mitglieder der Gewinnverteilung',
    es: 'Miembros de la participación en los beneficios',
    ru: 'Участники распределения прибыли',
    vi: 'Thành viên chia sẻ lợi nhuận',
  },
  psPayeeDesc: {
    zh_cn: '商户的分润成员。仅可以查询自己的账户余额及分润信息。',
    zhhant: '商户的分润成员。仅可以查询自己的账户余额及分润信息。',
    en: 'Merchants profit sharing members. Only their own account balances and profit-sharing information can be queried.',
    he: 'חברי שיתוף רווחים של מוכרים. ניתן לשאול אך ורק את יתרות החשבון ובמידע על שיתוף רווחים משלהם.',
    de: 'Gewinnverteilungsmitglieder von Händlern. Nur ihre eigenen Kontosalden und Gewinnverteilungsinformationen können abgefragt werden.',
    es: 'Miembros de la participación en los beneficios de comerciantes. Solo se pueden consultar sus propios saldos de cuentas e información de participación en beneficios.',
    ru: 'Участники распределения прибыли торговцев. Могут запрашиваться только их собственные балансы счетов и информация по распределению прибыли.',
    vi: 'Thành viên chia sẻ lợi nhuận của nhà bán lẻ. Chỉ có thể truy vấn số dư tài khoản và thông tin chia sẻ lợi nhuận của họ.',
  },
  activityAdd: {
    zh_cn: '新增活动',
    zhhant: '新增活动',
    en: 'Add Activity',
    he: 'הוספת פעילות',
    de: 'Aktivität hinzufügen',
    es: 'Añadir actividad',
    ru: 'Добавить активность',
    vi: 'Thêm hoạt động',
  },
  activityUpsert: {
    zh_cn: '编辑活动',
    zhhant: '编辑活动',
    en: 'Edit Activity',
    he: 'עריכת פעילות',
    de: 'Aktivität bearbeiten',
    es: 'Editar actividad',
    ru: 'Редактировать активность',
    vi: 'Chỉnh sửa hoạt động',
  },
  hlht: {
    zh_cn: '互联互通',
    zhhant: '互联互通',
    en: 'Interconnection',
    he: 'חיבור הדדי',
    de: 'Verbindung',
    es: 'Interconexión',
    ru: 'Межвзаимодействие',
    vi: 'Liên kết',
  },
  hlhtList: {
    zh_cn: '互联互通列表',
    zhhant: '互联互通列表',
    en: 'Interconnection List',
    he: 'רשימת חיבור הדדי',
    de: 'Verbindungsliste',
    es: 'Lista de interconexión',
    ru: 'Список межвзаимодействия',
    vi: 'Danh sách liên kết',
  },
  hlhtAdd: {
    zh_cn: '新增互联互通',
    zhhant: '新增互联互通',
    en: 'Add Interconnection',
    he: 'הוספת חיבור הדדי',
    de: 'Verbindung hinzufügen',
    es: 'Añadir interconexión',
    ru: 'Добавить межвзаимодействие',
    vi: 'Thêm liên kết',
  },
  hlhtUpsert: {
    zh_cn: '编辑互联互通',
    zhhant: '编辑互联互通',
    en: 'Edit Interconnection',
    he: 'עריכת חיבור הדדי',
    de: 'Verbindung bearbeiten',
    es: 'Editar interconexión',
    ru: 'Редактировать межвзаимодействие',
    vi: 'Chỉnh sửa liên kết',
  },
  hlhtAuthOP: {
    zh_cn: '互联互通授权操作',
    zhhant: '互联互通授权操作',
    en: 'Interconnection Authorization Operation',
    he: 'פעולת אישור חיבור הדדי',
    de: 'Verbindungsberechtigungsoperation',
    es: 'Operación de autorización de interconexión',
    ru: 'Операция авторизации межвзаимодействия',
    vi: 'Hoạt động ủy quyền liên kết',
  },
  hlhtDelete: {
    zh_cn: '删除互联互通',
    zhhant: '删除互联互通',
    en: 'Delete Interconnection',
    he: 'מחיקת חיבור הדדי',
    de: 'Verbindung löschen',
    es: 'Eliminar interconexión',
    ru: 'Удалить межвзаимодействие',
    vi: 'Xóa liên kết',
  },
  driverGroup: {
    zh_cn: '集团列表',
    zhhant: '集团列表',
    en: 'Group List',
    he: 'רשימת קבוצות',
    de: 'Gruppenliste',
    es: 'Lista de grupos',
    ru: 'Список групп',
    vi: 'Danh sách nhóm',
  },
  'group-detail': {
    zh_cn: '群组详情',
    zhhant: '群组详情',
    en: 'Group Detail',
    he: 'פרטי הקבוצה',
    de: 'Gruppen-Detail',
    es: 'Detalles del grupo',
    ru: 'Детали группы',
    vi: 'Chi tiết nhóm',
  },
  groupView: {
    zh_cn: '集团列表',
    zhhant: '集团列表',
    en: 'Group List',
    he: 'רשימת קבוצות',
    de: 'Gruppenliste',
    es: 'Lista de grupos',
    ru: 'Список групп',
    vi: 'Danh sách nhóm',
  },
  groupCtrl: {
    zh_cn: '集团基本管理',
    zhhant: '集团基本管理',
    en: 'Group Basic Management',
    he: 'ניהול בסיסי של קבוצות',
    de: 'Gruppen-Basisverwaltung',
    es: 'Gestión básica de grupos',
    ru: 'Базовое управление группами',
    vi: 'Quản lý cơ bản nhóm',
  },
  groupMemeView: {
    zh_cn: '集团成员查看',
    zhhant: '集團成員查看',
    en: 'Group Member View',
    he: 'תצוגת חברי קבוצה',
    de: 'Gruppenmitgliederansicht',
    es: 'Vista de miembros del grupo',
    ru: 'Просмотр участников группы',
    vi: 'Chế độ xem thành viên nhóm',
  },
  groupMemeCtrl: {
    zh_cn: '集团成员控制',
    zhhant: '集團成員控制',
    en: 'Group Member Control',
    he: 'בקרת חברי קבוצה',
    de: 'Gruppenmitgliedersteuerung',
    es: 'Control de miembro del grupo',
    ru: 'Контроль участника группы',
    vi: 'Kiểm soát thành viên nhóm',
  },
  groupWelletView: {
    zh_cn: '集团交易查看',
    zhhant: '集團交易查看',
    en: 'Group Transaction View',
    he: 'תצוגת עסקאות קבוצה',
    de: 'Gruppentransaktionsansicht',
    es: 'Vista de transacciones del grupo',
    ru: 'Просмотр транзакций группы',
    vi: 'Chế độ xem giao dịch nhóm',
  },
  groupWelletCtrl: {
    zh_cn: '集团交易控制',
    zhhant: '集團交易控制',
    en: 'Group Transaction Control',
    he: 'בקרת עסקאות קבוצה',
    de: 'Gruppentransaktionssteuerung',
    es: 'Control de transacciones del grupo',
    ru: 'Контроль транзакций группы',
    vi: 'Kiểm soát giao dịch nhóm',
  },
  stationEvse: {
    zh_cn: '站点设备',
    zhhant: '站点设备',
    en: 'Station Device',
    he: 'מכשיר תחנה',
    de: 'Stationsgerät',
    es: 'Dispositivo de estación',
    ru: 'Устройство станции',
    vi: 'Thiết bị trạm',
  },
  operationStrategy: {
    zh_cn: '运营策略',
    zhhant: '运营策略',
    en: 'Operation Strategy',
    he: 'אסטרטגיית ניהול',
    de: 'Betriebsstrategie',
    es: 'Estrategia de operación',
    ru: 'Стратегия эксплуатации',
    vi: 'Chiến lược hoạt động',
  },
  homeCharging: {
    zh_cn: '充电概览',
    zhhant: '充电概览',
    en: 'Charging Overview',
    he: 'סקירה טעינה',
    de: 'Übersichtladung',
    es: 'Vista general de la carga',
    ru: 'Обзор зарядки',
    vi: 'Tổng quan sạc',
  },
  financial: {
    zh_cn: '财务管理',
    zhhant: '财务管理',
    en: 'Financial',
    he: 'ניהול כספים',
    de: 'Finanzmanagement',
    es: 'Gestión financiera',
    ru: 'Финансовое управление',
    vi: 'Quản lý tài chính',
  },
  downQrcode: {
    zh_cn: '下载二维码',
    zhhant: '下载二维码',
    en: 'Download QR Code',
    he: 'הורד קוד QR',
    de: 'QR-Code herunterladen',
    es: 'Descargar código QR',
    ru: 'Загрузить QR код',
    vi: 'Tải mã QR',
  },
  walletTransaction: {
    zh_cn: '钱包交易列表',
    zhhant: '钱包交易列表',
    en: 'Wallet Transaction List',
    he: 'רשימת עסקאות ארנק',
    de: 'Wallet-Transaktionsliste',
    es: 'Lista de transacciones de la billetera',
    ru: 'Список транзакций кошелька',
    vi: 'Danh sách giao dịch ví',
  },
  walletTransactionCtrl: {
    zh_cn: '钱包充值',
    zhhant: '钱包充值',
    en: 'Wallet Recharge',
    he: 'טעינת ארנק',
    de: 'Wallet Aufladen',
    es: 'Recarga de billetera',
    ru: 'Пополнение кошелька',
    vi: 'Nạp tiền ví',
  },
  invoice: {
    zh_cn: '发票',
    zhhant: '發票',
    en: 'Invoice',
    he: 'מסמך',
    de: 'Rechnung',
    es: 'Factura',
    ru: 'Счет',
    vi: 'Hóa đơn',
  },
  invoiceBizList: {
    zh_cn: '电子发票配置',
    zhhant: '電子發票配置',
    en: 'Electronic Invoice Config',
    he: 'הגדרת מסמך אלקטרוני',
    de: 'Elektronische Rechnungs-Konfiguration',
    es: 'Configuración de factura electrónica',
    ru: 'Конфигурация электронной накладной',
    vi: 'Cấu hình hóa đơn điện tử',
  },
  invoiceBizUpsert: {
    zh_cn: '电子发票配置',
    zhhant: '電子發票配置',
    en: 'Electronic Invoice Config',
    he: 'הגדרת מסמך אלקטרוני',
    de: 'Elektronische Rechnungs-Konfiguration',
    es: 'Configuración de factura electrónica',
    ru: 'Конфигурация электронной накладной',
    vi: 'Cấu hình hóa đơn điện tử',
  },
  invoiceApplyList: {
    zh_cn: '发票申请',
    zhhant: '發票申請',
    en: 'Invoice Application',
    he: 'בקשת מסמך',
    de: 'Rechnungsanfrage',
    es: 'Solicitud de factura',
    ru: 'Запрос на счет',
    vi: 'Yêu cầu hóa đơn',
  },
  invoiceApplyItems: {
    zh_cn: '发票申请明细',
    zhhant: '發票申請明細',
    en: 'Invoice Application Detail',
    he: 'פרטי בקשת מסמך',
    de: 'Rechnungsanfragedetails',
    es: 'Detalle de la solicitud de factura',
    ru: 'Детали запроса на счет',
    vi: 'Chi tiết yêu cầu hóa đơn',
  },
  auditApplyItem: {
    zh_cn: '发票申请审核',
    zhhant: '發票申請審核',
    en: 'Invoice Application Audit',
    he: 'בדיקת בקשת מסמך',
    de: 'Rechnungsanfrageprüfung',
    es: 'Auditoría de la solicitud de factura',
    ru: 'Аудит запроса на счет',
    vi: 'Kiểm duyệt yêu cầu hóa đơn',
  },
  stationWhiteList: {
    zh_cn: '白名单',
    zhhant: '白名单',
    en: 'White List',
    he: 'רשימת לבנה',
    de: 'Weißliste',
    es: 'Lista blanca',
    ru: 'Белый список',
    vi: 'Danh sách trắng',
  },
  profitsharingReport: {
    zh_cn: '清分账单',
    zhhant: '清分账单',
    en: 'Profitsharing Report',
    he: 'דוח שיתוף פעולה',
    de: 'Gewinnverteilungsbericht',
    es: 'Informe de la comisión',
    ru: 'Отчет о распределении доходов',
    vi: 'Báo cáo hoa hồng',
  },
  finance: {
    zh_cn: '财务',
    zhhant: '財務',
    en: 'Finance',
    he: 'כספים',
    de: 'Finanzen',
    es: 'Finanzas',
    ru: 'Финансы',
    vi: 'Tài chính',
  },
  financeDesc: {
    zh_cn: '财务管理员，拥有订单，账单，清分，提现等权限。 权限维度(商户)。',
    zhhant: '財務管理員，擁有訂單，帳單，清分，提現等權限',
    en: 'Finance Manager, has order, bill, profitsharing, withdrawal and other permissions',
    he: 'מנהל כספים, יש הזמנה, חשבונית, שיתוף פעולה, משיכה וכיוצא בזה',
    de: 'Finanzmanager, hat Bestellung, Rechnung, Profitsharing, Auszahlung und andere Berechtigungen',
    es: 'Gerente de finanzas, tiene pedido, factura, comisión, retiro y otros permisos',
    ru: 'Финансовый менеджер, имеет заказ, счет, sharing, вывод и другие разрешения',
    vi: 'Quản trị viên tài chính, có quyền đơn hàng, hóa đơn, chia sẻ lợi nhuận, rút tiền và các quyền khác',
  },
  ops: {
    zh_cn: '运维管理员',
    zhhant: '運維管理員',
    en: 'Ops Administrator',
    vi: 'Quản trị viên quản lý',
    es: 'Operaciones Administrador',
    ru: 'Операционный администратор',
    he: 'מנהל ניהול',
    de: 'Ops Administrator',
  },
  opsDesc: {
    zh_cn: '运维管理员，管理站点设备资源。拥有站点，设备，估计，OTA等权限。权限维度(商户)。',
    zhhant: '運維管理員，管理站點設備資源。擁有站點，設備，估計，OTA等權限。权限维度(商户)。',
    en: 'Ops Administrator, manage site resources. Owns site, device, estimate, OTA, etc. Permission dimensions (merchant).',
    vi: 'Quản trị viên quản lý, quản lý các thiết bị, các thiết bị, ước tính, OTA và các quyền khác',
    es: 'Operations Administrator, manage site resources. Owns site, device, estimate, OTA, etc. Permission dimensions (merchant).',
    ru: 'Операционный администратор, управляет ресурсами сайта. Собствует сайт, устройство, оценка, OTA и т.д. Размерность прав (компания).',
    he: 'מנהל ניהול, מנהל משאבים באתר. בעל אתר, התקן, הערכה, OTA וכו. Dimension (merchant).',
    de: 'Ops Administrator, manage site resources. Owns site, device, estimate, OTA, etc. Permission dimensions (merchant).',
  },
  stationView: {
    zh_cn: '站点只读管理员',
    zhhant: '站點只讀管理員',
    en: 'Station Read-Only Administrator',
    vi: 'Quản trị viên chỉ đọc',
    es: 'Administrador de solo lectura de la estación',
    ru: 'Администратор с доступом только для чтения',
    he: 'מנהל קריאה בלבד',
    de: 'Station Read-Only Administrator',
  },
  stationViewDesc: {
    zh_cn: '站点只读管理员，拥有站点只读权限。权限维度(站点)。',
    zhhant: '站點只讀管理員，擁有站點只讀權限。权限维度(站点)。',
    en: 'Station Read-Only Administrator, has read only permission for site. Permission dimensions (site).',
    vi: 'Quản trị viên chỉ đọc, quyền đọc duy nhất',
    es: 'Administrador de solo lectura de la estación, tiene permiso de solo lectura para el sitio. Dimension (sitio).',
    ru: 'Администратор с доступом только для чтения, имеет разрешение на чтение для сайта. Размерность прав (сайт).',
    he: 'מנהל קריאה בלבד, יש הרשאה לקריאה ב לבד. Dimension (sitio).',
    de: 'Station Read-Only Administrator, has read only permission for site. Permission dimensions (site).',
  },
  agentOperatorView: {
    zh_cn: '托管商户只读管理员',
    zhhant: '托管商户只读管理员',
    en: 'Hosting Operator Read-Only',
    vi: 'Nhà cung cấp quản trị chỉ đọc',
    es: 'Operador de Hosting Read-Only',
    ru: 'Только чтение оператора хостинга',
    he: 'מארח רק קריאה',
    de: 'Hosting Operator Read-Only',
  },
  agentOperatorViewDesc: {
    zh_cn: '托管商户只读管理员，拥有托管商户只读权限。权限维度(商户)。',
    zhhant: '托管商户只读管理员，拥有托管商户只读权限。权限维度(商户)。',
    en: 'Hosting Operator Read-Only, has read only permission for hosting operator. Permission dimensions (merchant).',
    vi: 'Nhà cung cấp quản trị chỉ đọc, quyền đọc duy nhất',
    es: 'Operador de Hosting Read-Only, tiene permiso de solo lectura para el operador de alojamiento. Dimension (comerciante).',
    ru: 'Только чтение оператора хостинга, имеет разрешение на чтение для оператора хостинга. Размер (коммерçant).',
    he: 'מארח רק קריאה, יש הרשאה לקריאה בלבד. Dimension (comerciante).',
    de: 'Hosting Operator Read-Only, has read only permission for hosting operator. Permission dimensions (merchant).',
  },
  brandOperatorView: {
    zh_cn: '品牌商户只读管理员',
    zhhant: '品牌商户只读管理员',
    en: 'Brand Operator Read-Only Admin',
    vi: 'Nhà cung cấp thương hiệu Read-Only',
    es: 'Operador de Marca Read-Only Admin',
    ru: 'Администратор с доступом только для чтения',
    he: 'מנהל קריאה בלבד',
    de: 'Brand Operator Read-Only Admin',
  },
  brandOperatorViewDesc: {
    zh_cn: '品牌商户只读管理员, 拥有品牌商户只读权限。权限维度(商户)。',
    zhhant: '品牌商户只读管理员, 拥有品牌商户只读权限。权限维度(商户)。',
    en: 'Brand Operator Read-Only Admin, has brand operator read-only permission. Permission dimension (Operator).',
    vi: 'Nhà cung cấp thương hiệu Read-Only Admin, có quyền xem nhà cung cấp thương hiệu Read-Only. Phân quyền theo nhà cung cấp thương hiệu.',
    es: 'Operador de Marca Read-Only Admin, tiene permiso de solo lectura de operador de marca. Dimensión de permiso (Operador).',
    ru: 'Администратор с доступом только для чтения, имеет доступ только для чтения. Размер разрешения (Оператор).',
    he: 'מנהל קריאה בלבด של מפעיל, יש הרשאה לקריאה בלבד. Dimension (Operator).',
    de: 'Brand Operator Read-Only Admin, has brand operator read-only permission. Permission dimension (Operator).',
  },
  profitsharingWalletBind: {
    zh_cn: '商户钱包绑定用户',
    zhhant: '商户钱包绑定用户',
    en: 'Merchant Wallet Bind User',
    vi: 'Người dùng nạp ví',
    es: 'Usuario de billetera de comerciante',
    ru: 'Пользователь, который привязывает кошелек',
    he: 'משתמש מחובר לתיק',
    de: 'Merchant Wallet Bind User',
  },
  stationWhitelist: {
    zh_cn: '白名单列表',
    zhhant: '白名单列表',
    en: 'White List',
    vi: 'Danh sách trắng',
    es: 'Lista blanca',
    ru: 'Белый список',
    he: 'רשימה לבנה',
    de: 'White List',
  },
  stationWhiteEdit: {
    zh_cn: '白名单编辑',
    zhhant: '白名单编辑',
    en: 'White List Edit',
    vi: 'Chỉnh sửa danh sách trắng',
    es: 'Editar lista blanca',
    ru: 'Редактировать белый список',
    he: 'עריכת רשימה לבנה',
    de: 'White List Edit',
  },
  occupyOrder: {
    zh_cn: '占桩订单',
    zhhant: '占樁訂單',
    en: 'Occupy Order',
    he: 'Occupy Order',
    de: 'Occupy Order',
    es: 'Occupy Order',
    ru: 'Occupy Order',
    vi: 'Occupy Order',
  },
  occupySettelment: {
    zh_cn: '占桩结算',
    zhhant: '占樁結算',
    en: 'Occupy Settelment',
    he: 'Occupy Settelment',
    de: 'Occupy Settelment',
    es: 'Occupy Settelment',
    ru: 'Occupy Settelment',
    vi: 'Occupy Settelment',
  },
  essDevice: {
    zh_cn: '储能设备管理',
    zhhant: '储能設備管理',
    en: 'ESS Device Management',
    vi: 'Quản lý thiết bị ESS',
    es: 'Gestión de dispositivos ESS',
    ru: 'Управление устройствами ESS',
    he: 'ניהול מכשירי ESS',
    de: 'ESS Device Management',
  },
  occupyList: {
    zh_cn: '占桩订单列表',
    zhhant: '占樁訂單列表',
    en: 'Occupy Order List',
    he: 'Occupy Order List',
    de: 'Occupy Order List',
    es: 'Occupy Order List',
    ru: 'Occupy Order List',
    vi: 'Occupy Order List',
  },
  walletRefundCtrl: {
    zh_cn: '钱包退款',
    zhhant: '錢包退款',
    en: 'Wallet Refund',
    vi: 'Hoàn tiền ví',
    es: 'Reembolso de billetera',
    ru: 'Возврат средств на кошелек',
    he: 'החזר כסף לחשבון',
    de: 'Wallet Refund',
  },
  walletWithholdCtrl: {
    zh_cn: '钱包扣款',
    zhhant: '錢包扣款',
    en: 'Wallet Withhold',
    vi: 'Giữ ví',
    es: 'Retención de billetera',
    ru: 'Заблокировано на кошельке',
    he: 'החזקת תיק',
    de: 'Wallet Withhold',
  },
  essList: {
    zh_cn: '光储设备列表',
    zhhant: '光储设备列表',
    en: 'ESS Device List',
    vi: 'Danh sách thiết bị ESS',
    es: 'Lista de dispositivos ESS',
    ru: 'Список устройств ESS',
    he: 'רשימת מכשירי ESS',
    de: 'ESS Device List',
  },
  essInfo: {
    zh_cn: '光储设备信息',
    zhhant: '光储设备信息',
    en: 'ESS Device Info',
    vi: 'Thông tin thiết bị ESS',
    es: 'Información de dispositivo ESS',
    ru: 'Информация об устройстве ESS',
    he: 'מידע מכשיר ESS',
    de: 'ESS Device Info',
  },
  essAdd: {
    zh_cn: '添加光储设备',
    zhhant: '添加光储设备',
    en: 'Add ESS',
    vi: 'Thêm ESS',
    es: 'Añadir ESS',
    ru: 'Добавить ESS',
    he: 'הוסף ESS',
    de: 'ESS Hinzufügen',
  },
  essUpdate: {
    zh_cn: '光储设备更新',
    zhhant: '光储设备更新',
    en: 'Update ESS',
    vi: 'Cập nhật ESS',
    es: 'Actualizar ESS',
    ru: 'Обновить ESS',
    he: 'עדכן ESS',
    de: 'ESS Aktualisieren',
  },
  essDelete: {
    zh_cn: '删除光储设备',
    zhhant: '删除光储设备',
    en: 'Delete ESS',
    vi: 'Xóa ESS',
    es: 'Eliminar ESS',
    ru: 'Удалить ESS',
    he: 'מחק ESS',
    de: 'ESS Löschen',
  },
  changePwd: {
    zh_cn: '修改密码',
    zhhant: '修改密碼',
    en: 'Change Password',
    vi: 'Thay đổi mật khẩu',
    es: 'Cambiar contraseña',
    ru: 'Изменить пароль',
    he: 'שינוי סיסמה',
    de: 'Passwort ändern',
  },
  stationDelete: {
    zh_cn: '站点删除',
    zhhant: '站點刪除',
    en: 'Station Delete',
    vi: 'Xóa trạm',
    es: 'Eliminar estación',
    ru: 'Удалить станцию',
    he: 'סיים תצ\'אט',
    de: 'Station löschen',
  },
  walletSettlement: {
    zh_cn: '钱包结算',
    zhhant: '錢包结算',
    en: 'Wallet Settlement',
    vi: 'Xác nhận thanh toán ví',
    es: 'Reembolso de billetera',
    ru: 'Возврат средств на кошелек',
    he: 'החזר כסף לחשבון',
    de: 'Wallet Refund',
  },
  supportRescueOrderOperate: {
    zh_cn: '救援订单编辑',
    zhhant: '救援訂單編輯',
    en: 'Rescue Order Edit',
    vi: 'Cung cấp dịch vụ',
    es: 'Operador de marca',
    ru: 'Бренд-оператор',
    he: 'תורות תפריט',
    de: 'Markenoperator',
  },
  supportRescueConfigOperate: {
    zh_cn: '救援配置编辑',
    zhhant: '救援配置編輯',
    en: 'Rescue Config Edit',
    vi: 'Cung cấp dịch vụ',
    es: 'Operador de marca',
    ru: 'Бренд-оператор',
    he: 'תורות תפריט',
    de: 'Markenoperator',
  },
  supportCooperationOperate: {
    zh_cn: '投资合作编辑',
    zhhant: '投資合作編輯',
    en: 'Cooperation Edit',
    vi: 'Cung cấp dịch vụ',
    es: 'Operador de marca',
    ru: 'Бренд-оператор',
    he: 'תורות תפריט',
    de: 'Markenoperator',
  },
  walletSummary: {
    zh_cn: '钱包总览',
    zhhant: '錢包總覽',
    en: 'Wallet Summary',
    vi: 'Tổng quan ví',
    es: 'Resumen de billetera',
    ru: 'Обзор кошелька',
    he: 'עפרת תקציב',
    de: 'Kontosübersicht',
  },
  reportingSummary: {
    zh_cn: '账单总览',
    zhhant: '账单總覽',
    en: 'Reporting Summary',
    vi: 'Tổng quan báo cáo',
    es: 'Resumen de informes',
    ru: 'Обзор отчетов',
    he: 'עפרת דוחות',
    de: 'Berichtszusammenfassung',
  },
  plockList: {
    zh_cn: '地锁列表',
    zhhant: '地鎖列表',
    en: 'Parking Lock List',
    vi: 'Danh sách khóa xe',
    es: 'Lista de bloqueos de estacionamiento',
    ru: 'Список блокировок для стоянки',
    he: 'רשימת נעילות חניה',
    de: 'Parksperrenliste',
  },
  plockInfo: {
    zh_cn: '地锁详情',
    zhhant: '地鎖詳情',
    en: 'Parking Lock Info',
    vi: 'Thông tin khóa xe',
    es: 'Información de bloqueos de estacionamiento',
    ru: 'Информация о блокировке для стоянки',
    he: 'פרטי נעילה חניה',
    de: 'Parksperreninfo',
  },
  plockAdd: {
    zh_cn: '新增地锁',
    zhhant: '新增地鎖',
    en: 'Add Parking Lock',
    vi: 'Thêm khóa xe',
    es: 'Agregar bloqueos de estacionamiento',
    ru: 'Добавить блокировку для стоянки',
    he: 'הוסף נעילות חניה',
    de: 'Parksperre hinzufügen',
  },
  plockEdit: {
    zh_cn: '编辑地锁',
    zhhant: '編輯地鎖',
    en: 'Edit Parking Lock',
    vi: 'Chỉnh sửa khóa xe',
    es: 'Editar bloqueos de estacionamiento',
    ru: 'Изменить блокировку для стоянки',
    he: 'ערוך נעילות חניה',
    de: 'Parksperre bearbeiten',
  },
  plockDel: {
    zh_cn: '删除地锁',
    zhhant: '刪除地鎖',
    en: 'Delete Parking Lock',
    vi: 'Xóa khóa xe',
    es: 'Eliminar bloqueos de estacionamiento',
    ru: 'Удалить блокировку для стоянки',
    he: 'מחק נעילות חניה',
    de: 'Parksperre löschen',
  },
  plockBind: {
    zh_cn: '地锁绑定',
    zhhant: '地鎖綁定',
    en: 'Bind Parking Lock',
    vi: 'Khóa xe',
    es: 'Vincular bloqueos de estacionamiento',
    ru: 'Привязать блокировку для стоянки',
    he: 'קשר נעילות חניה',
    de: 'Parksperre binden',
  },
  plockUnbind: {
    zh_cn: '地锁解绑',
    zhhant: '地鎖解綁',
    en: 'Unbind Parking Lock',
    vi: 'Gỡ khóa xe',
    es: 'Desvincular bloqueos de estacionamiento',
    ru: 'Открепить блокировку для стоянки',
    he: 'פרוש נעילות חניה',
    de: 'Parksperre entbinden',
  },
  plockRefresh: {
    zh_cn: '地锁刷新',
    zhhant: '地鎖刷新',
    en: 'Refresh Parking Lock',
    vi: 'Làm mới khóa xe',
    es: 'Actualizar bloqueos de estacionamiento',
    ru: 'Обновить блокировку для стоянки',
    he: 'רענן נעילות חניה',
    de: 'Parksperre aktualisieren',
  },
  plockReboot: {
    zh_cn: '地锁重启',
    zhhant: '地鎖重啟',
    en: 'Reboot Parking Lock',
    vi: 'Khởi động lại khóa xe',
    es: 'Reiniciar bloqueos de estacionamiento',
    ru: 'Перезагрузить блокировку для стоянки',
    he: 'אתחל נעילות חניה',
    de: 'Parksperre neu starten',
  },
  plockReset: {
    zh_cn: '地锁重置',
    zhhant: '地鎖重置',
    en: 'Reset Parking Lock',
    vi: 'Đặt lại khóa xe',
    es: 'Restablecer bloqueos de estacionamiento',
    ru: 'Сбросить блокировку для стоянки',
    he: 'אפס נעילות חניה',
    de: 'Parksperre zurücksetzen',
  },
  plockOpen: {
    zh_cn: '地锁开启(降)',
    zhhant: '地鎖開啟(降)',
    en: 'Open Parking Lock',
    vi: 'Mở khóa xe',
    es: 'Abrir bloqueos de estacionamiento',
    ru: 'Открыть блокировку для стоянки',
    he: 'פתח נעילות חניה',
    de: 'Parksperre öffnen',
  },
  plockClose: {
    zh_cn: '地锁关闭(升)',
    zhhant: '地鎖關閉(升)',
    en: 'Close Parking Lock',
    vi: 'Đóng khóa xe',
    es: 'Cerrar bloqueos de estacionamiento',
    ru: 'Закрыть блокировку для стоянки',
    he: 'סגור נעילות חניה',
    de: 'Parksperre schließen',
  },
  plockConfigSet: {
    zh_cn: '地锁参数设置',
    zhhant: '地鎖參數設定',
    en: 'Set Parking Lock Config',
    vi: 'Thiết lập khóa xe',
    es: 'Configurar bloqueos de estacionamiento',
    ru: 'Задать параметры блокировки для стоянки',
    he: 'הגדר את הגדרות נעילות חניה',
    de: 'Parksperre-Konfiguration einstellen',
  },
  plockConfigGet: {
    zh_cn: '地锁参数获取',
    zhhant: '地鎖參數獲取',
    en: 'Get Parking Lock Config',
    vi: 'Lấy khóa xe',
    es: 'Obtener bloqueos de estacionamiento',
    ru: 'Получить параметры блокировки для стоянки',
    he: 'קבל הגדרות נעילות חניה',
    de: 'Parksperre-Konfiguration abrufen',
  },
  plockClearAlarm: {
    zh_cn: '地锁报警清除',
    zhhant: '地鎖警報清除',
    en: 'Clear Parking Lock Alarm',
    vi: 'Xóa báo động khóa xe',
    es: 'Limpiar alarma de bloqueos de estacionamiento',
    ru: 'Очистить сигнал блокировки для стоянки',
    he: 'מחק ההתראה של נעילת חניה',
  },
}
